import { useState } from "react"
import { Card } from "../components/ui/card"
import testService from "../services/testService"
import { useParams, useNavigate } from "react-router-dom"
import { toast } from "sonner"
import { useEffect } from "react"
import { CircleHelp} from "lucide-react"
import { cn } from "../lib/utils"
import { Button } from "../components/ui/button"

export default function TestsPage () {

  const { course_id} = useParams()

  const navigate = useNavigate()
  const [tests, setTests] = useState([])

  const fetchTests = async () => {
    try {
      const response = await testService.getTestByCourseId(course_id)
      setTests(response.data)

    } catch (error) {
      toast.error("Lỗi lấy dữ liệu!")
      console.error(error)
    }
  }

  useEffect(() => {
    if (course_id) {
      fetchTests()
    }
  }, [course_id])

  return (
    <div className="py-8 flex justify-center">

      <Card className="min-w-lg w-1/2 py-8 px-4">
      <h1 className="font-bold text-center font-[Phudu] text-xl text-primary">
        BÀI KIỂM TRA CUỐI KHÓA
      </h1>
      <h1 className="font-bold text-center font-[Phudu] text-xl">
      {
        tests.length>0 ?
        tests[0].title
        : null
      }
      </h1>
      <div className="mt-8">
        {tests.map((test, index) => (
          <div className={cn("grid grid-cols-2 p-4 space-y-4 bg-slate-600 text-white rounded-lg")}>
            <div className="space-y-4">
              <h2 className="font-bold text-lg">Bài kiểm tra #{index+1}</h2>
              <div className="flex flex-row justify-center gap-2 w-max text-md">
                <CircleHelp />
                <p className="space-x-4">
                {test.total_questions}
                {" "}
                câu hỏi
                </p>
              </div>

            </div>
            <div className="flex justify-end items-center">
            <Button variant="secondary" className="rounded-sm" onClick={() => navigate(`/courses/${course_id}/test/${test.id}`)}>
              {
                test.is_done ?
                `${test.highest_score} điểm | Làm lại `
                :
                "Làm bài"
              }

            </Button>
            </div>
          </div>
        ))}
        </div>
      </Card>
    </div>

  )
}
